import { render, staticRenderFns } from "./ModuleContentMenu.vue?vue&type=template&id=7cf5e4f6"
import script from "./ModuleContentMenu.vue?vue&type=script&lang=js"
export * from "./ModuleContentMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports